import Box from "@mui/material/Box";
import React, {useContext, useEffect, useRef} from "react";
import {useParams} from "react-router-dom";
import AgenticEditorInner from "./AgenticEditorInner";
import {AutoLayoutMode, Engine} from "@rendley/sdk";
import {WaveformClip} from "../../editor/custom/WaveFormClip";
import {getCanvasElement} from "../../editor/utils/dom/getCanvasElement";
import {useError} from "react-use";
import RendleyBridge from "../../agenticEditor/RendleyBridge";
import AspectRatioSelectCard from "../NewEditor/ClipSizeCard";
import {DisplayToClipSizeId} from "../../utils/utils";
import {RendleyStore} from "../../editor/store/RendleyStore";
import {autorun} from "mobx";
import AgenticEditorTopbar from "./AgenticEditorTopbar";
import {SUBTITLES_STYLES_PATH_CDN, TITLES_PATH_CDN, FILTERS_PATH_CDN, TRANSITIONS_PATH_CDN, EFFECTS_PATH_CDN} from "../../agenticEditor/config/config";
import {StockMediaService} from "../../editor/services/StockMediaService";
import {FetchContext} from "../../context/FetchContext";
import {AuthContext} from "../../context/AuthContext";


const AgenticEditor = () => {

    const {projectId} = useParams();

    const compositionContainerRef = useRef(null);
    const canvasRef = useRef(null);

    const aspectRatioRef = useRef(null);
    const [aspectRatioId, setAspectRatioId] = React.useState(DisplayToClipSizeId(RendleyStore.display));

    const fetchContext = useContext(FetchContext);
    const authContext = useContext(AuthContext);

    // Refresh project urls
    useEffect(() => {
        if (projectId === null) return;

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${projectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls();
        return () => {
        };
    }, [projectId]);

    useEffect(() => {
        const disposeAutorun = autorun(() => {
            const aspectRatioId = DisplayToClipSizeId(RendleyStore.display);
            setAspectRatioId(aspectRatioId);
        });

        // Cleanup autorun on component unmount
        return () => {
            disposeAutorun();
        };
    }, [setAspectRatioId]);


    const pageStyle = {
        display: 'flex',
        flexDirection: 'column',
        background: "#F3F4F5",
        paddingTop: "10px",
        paddingLeft: "32px",
        paddingRight: "10px",
        height: "100vh",
        width: "100vw",
        gap: "28px",
        overflow: 'hidden',
    }

    const initializeEditor = async () => {
        // Step 1: Initialize the engine if not already initialized
        if (!Engine.getInstance().isInitialized()) {
            try {
                await Engine.getInstance().init({
                    display: {
                        width: 1920,
                        height: 1080,
                        backgroundColor: "#000000",
                        view: getCanvasElement(),
                    },
                    license: {
                        licenseName: "Libretto",
                        licenseKey: "7324FD51F1255979246B0001",
                    },
                });
            } catch (e) {
                console.error("Error initializing engine: ", e);
            }

            try {
                await StockMediaService.getInstance().init({
                    pexelsApiKey: "ZPSMxFlBYLs9JQmTeFmSkeXDFf9VjJqHSAJCk6y5RyDFGmXV9edrThpl",
                    giphyApiKey: "cGA8JsUtlRseBgqdBYSCCsFxgLYlm3tu",
                });

            } catch (e) {
                console.error("Error initializing stock media service: ", e);
            }
            try {
                await RendleyBridge.init({
                    filtersPath: FILTERS_PATH_CDN,
                    effectsPath: EFFECTS_PATH_CDN,
                    transitionsPath: TRANSITIONS_PATH_CDN,
                    titlesPath: TITLES_PATH_CDN,
                    subtitlesStylesPath: SUBTITLES_STYLES_PATH_CDN,
                });
            } catch (e) {
                console.error("Error initializing RendleyBridge: ", e);
            }

        }

        Engine.getInstance().getSettings().setViewAutoLayoutOnResize(AutoLayoutMode.PREFER_HEIGHT);
        Engine.getInstance().getUndoManager().setEnabled(true);

        await RendleyBridge.init({

        })
    }

    useEffect(() => {
        if (canvasRef.current && !Engine.getInstance().isInitialized()) {
            initializeEditor().then(() => {
                console.log("Initialized editor");
            }).catch((e) => {
                console.log("Error initializing editor: ", e);
            })
        }
    }, [canvasRef.current]);

    return (
        <Box sx={pageStyle}>
            <AgenticEditorTopbar canvasRef={canvasRef} containerRef={compositionContainerRef} projectId={projectId}
                editTitle={"Sample"} textEditorVisible={false} videoPlayerVisible={true} aspectRatioRef={aspectRatioRef} aspectRatioId={aspectRatioId}
            editId={""}/>
            <AgenticEditorInner
                projectId={projectId} compositionContainerRef={compositionContainerRef} canvasRef={canvasRef} videoPlayerVisible={true} textEditorVisible={true}/>
        </Box>
    )
}

export default AgenticEditor;